import Ping from "./Ping"

export const LoadingCustom = () => {
    return (
        <div className="bg-black flex items-center justify-center h-screen">
            <Ping />
        </div>
    )
}